import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';

import Grid from '@material-ui/core/Grid';
import { makeStyles, createStyles } from '@material-ui/core/styles';

import { GetMeasureInfoType, MeasureInfoType, SelectDataType } from './FeatureParameter';
import FeatureParameterSelectItem from './FeatureParameterSelectItem';
import FeatureParameterGrid, { RefreshGridDataType } from './FeatureParameterGrid';
import FeatureParameterExportCSV from './FeatureParameterExportCSV';

const useStyles = makeStyles(
  createStyles({
    tableContainer: {
      maxHeight: 'calc(100vh - 258px)',
    },
    paper: {
      background: '#FFFFEE',
    },
  })
);

const FeatureParameterPage: React.FC = () => {
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [measureInfo, setMeasereInfo] = useState<MeasureInfoType[]>([]);
  const [selectData, setSelectData] = useState<SelectDataType>({
    mesid: 1,
    devIndex: 1,
    year: Number(dayjs(new Date()).format('YYYY')),
    month: Number(dayjs(new Date()).format('MM')),
  });
  const [refreshGridData, setRefreshGridData] = useState<RefreshGridDataType>({
    selectDataType: {
      mesid: 1,
      devIndex: 1,
      year: Number(dayjs(new Date()).format('YYYY')),
      month: Number(dayjs(new Date()).format('MM')),
    },
  });
  const [targetName, setTargetName] = useState<string>('');

  useEffect(() => {
    GetMeasureInfoType().then((ret) => {
      for (var i in ret) {
        ret[i].id = Number(i + 1);
      }
      var target = ret.find((row) => row.id === 1);
      /* 画面表示時に先頭の機器名を読み込む */
      setTargetName(`${target?.DevNo} ${target?.DevName}`);
      setMeasereInfo(ret);
    });
  }, []);

  const handleSelectDataChange = (value: SelectDataType) => {
    var target = measureInfo.find((row) => row.id === value.mesid);
    console.debug(['handleSelectDataChange', target]);
    value.devIndex = target?.DevIndex ?? 0;
    setSelectData({ ...value });
    setRefreshGridData({ selectDataType: value });
    setTargetName(`${target?.DevNo} ${target?.DevName}`);
  };

  const handleLoadingStateChange = (value: boolean): void => setLoading(value);

  return (
    <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center">
      <Grid item xs={11}>
        <FeatureParameterSelectItem
          mesInfoList={measureInfo}
          onChangeSelectDataEvent={handleSelectDataChange}
          selectData={selectData}
          loading={loading}
        />
      </Grid>
      <Grid item xs={1}>
        <FeatureParameterExportCSV refreshGridData={refreshGridData} selectData={selectData} targetName={targetName} />
      </Grid>
      <Grid item xs={12}>
        <FeatureParameterGrid
          tableContainerStyle={classes.tableContainer}
          refreshGridData={refreshGridData}
          updateLoadginState={handleLoadingStateChange}
        />
      </Grid>
    </Grid>
  );
};

export default FeatureParameterPage;
